import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { IQuestionListItem, NoteItem } from '@/types';
import './index.less';
import { addOrCancelNote, addUpdateNote, deleteNote, getNoteList, getQuestionSquare } from '@/apis';
import { Avatar, Checkbox, Input, List, message } from 'antd';
import DOMPurify from 'dompurify';
import { useAppContext } from '@/context/app-contex';

interface IProps {
    questionItem: IQuestionListItem;
    paperDataId?: number;
}

const QuestionAnswerAndNote: React.FC<IProps> = props => {
    const { questionItem, paperDataId } = props;
    const { projectId, subjectId, questionId } = questionItem;

    const { answerFunction } = useAppContext();

    const [activeTab, setActiveKey] = useState<'note' | 'answerSquare'>('note');

    const [answerList, setAnswerList] = useState<
        {
            content: string; // 问题
            nick_name: string; // 昵称
            picture: string; // 头像
            id: number;
        }[]
    >([]);

    const [noteList, setNoteList] = useState<NoteItem[]>([]);
    const [inputValue, setInputValue] = useState<string>();
    const [isOpen, setIsOpen] = useState(false); // 是否公开笔记
    const [isShowNote, setIsShowNote] = useState(true);
    const yourSelfNote = useRef<NoteItem>();

    const getAnswerList = async () => {
        const ret = await getQuestionSquare({
            page: 1,
            ps: 30,
            project_id: questionItem.projectId,
            type: 2,
            resource_id: questionItem.questionId,
            resource_type: 2,
        });
        if (ret.status === 0) {
            setAnswerList(ret.result);
        }
    };

    useEffect(() => {
        getAnswerList();
    }, []);

    const goGbot = async () => {
        answerFunction?.(questionItem);
    };

    const reqNoteList = async () => {
        const ret = await getNoteList({
            questionId,
        });
        if (ret.status === 0) {
            const list = ret.result;
            yourSelfNote.current = list.find((note: { isSelf: any }) => note.isSelf);
            if (yourSelfNote.current) {
                setIsShowNote(false);
            }
            setNoteList(list);
        }
    };
    useEffect(() => {
        reqNoteList();
    }, [questionId]);

    const changeSelfNote = () => {
        setIsShowNote(true);
        setIsOpen(yourSelfNote.current?.noteState === 0 ? true : false);
        setInputValue(DOMPurify.sanitize(yourSelfNote.current?.noteContent || ''));
    };

    const deleteSelfNote = async () => {
        const ret = await deleteNote(yourSelfNote.current!.noteId);
        if (ret.status === 0) {
            message.success('已移除您的笔记');
            yourSelfNote.current = undefined;
            setInputValue(undefined);
            reqNoteList();
            setIsShowNote(true);
        }
    };

    const handleSaveNote = async () => {
        const ret = await addUpdateNote({
            isSelf: isOpen ? 0 : 1,
            noteContent: inputValue!,
            noteId: yourSelfNote.current?.noteId || undefined,
            paperDataId: paperDataId,
            projectId: projectId,
            questionId: questionId,
            subjectId: subjectId, // 科目ID
        });
        if (ret.status === 0) {
            setIsShowNote(false);
            message.success(yourSelfNote.current?.noteId ? '修改笔记成功' : '已添加您的笔记');
            reqNoteList();
        }
    };

    const onChangeInputValue = (e: any) => {
        setInputValue(DOMPurify.sanitize(e.target.value));
    };

    const addCancelLike = async (noteItem: NoteItem) => {
        const ret = await addOrCancelNote({
            isFabulous: !!noteItem.isFabulous,
            noteId: noteItem.noteId,
            projectId,
            questionId,
            subjectId,
        });
        if (ret.status === 0) {
            message.success(noteItem.isFabulous ? '已取消点赞' : '点赞成功');
            reqNoteList();
        }
    };

    return (
        <div className="sub-tiku__question-plaza-container">
            <div className="sub-tiku__plaza-tab-box">
                {/* <div
                    className={classNames('sub-tiku__question-user-answer', {
                        'sub-tiku__active-tab': activeTab === 'answerSquare',
                    })}
                    onClick={() => {
                        setActiveKey('answerSquare');
                    }}
                >
                    <div />
                    问答广场
                </div> */}
                <div
                    className={classNames('sub-tiku__question-note-tab', {
                        'sub-tiku__active-tab': activeTab === 'note',
                    })}
                    onClick={() => {
                        setActiveKey('note');
                    }}
                >
                    <div />
                    笔记
                </div>
            </div>

            <div
                className={classNames({
                    'sub-tiku__active-square': activeTab === 'answerSquare',
                    'sub-tiku__in-active-square': activeTab !== 'answerSquare',
                })}
            >
                <div className="sub-tiku__question-answer-square">
                    <div className="sub-tiku__square-img-box">
                        <div className="sub-tiku__go-gbot-btn" onClick={goGbot}>
                            去提问
                        </div>
                        <img alt="图片" src="http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202407/19/4d618_20240719155415.png" />
                    </div>

                    {answerList.length > 0 && (
                        <List
                            style={{ marginTop: 42 }}
                            itemLayout="horizontal"
                            dataSource={answerList}
                            renderItem={(item, index) => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Avatar src={item.picture} />}
                                        title={item.nick_name}
                                        description={item.content}
                                    />
                                </List.Item>
                            )}
                        />
                    )}
                </div>
            </div>

            <div
                className={classNames({
                    'sub-tiku__active-note': activeTab === 'note',
                    'sub-tiku__in-active-note': activeTab !== 'note',
                })}
            >
                <div>
                    {isShowNote && (
                        <>
                            <Input.TextArea
                                autoSize={{ minRows: 4 }}
                                maxLength={3000}
                                onChange={onChangeInputValue}
                                placeholder="请填写笔记"
                                value={inputValue}
                            />
                            <div className="sub-tiku__sendCommentActions">
                                <div style={{ marginRight: 24 }}>
                                    <Checkbox checked={isOpen} onChange={e => setIsOpen(e.target.checked)} /> 是否公开笔记
                                </div>
                                <div
                                    className={classNames('sub-tiku__tiku-default-btn', { 'sub-tiku__daisabled': !inputValue })}
                                    onClick={handleSaveNote}
                                >
                                    提交笔记
                                </div>
                            </div>
                        </>
                    )}
                    {yourSelfNote.current && (
                        <div className="sub-tiku__commentItem" key={yourSelfNote.current.noteId}>
                            <div className="sub-tiku__commentHead">
                                <div
                                    className="sub-tiku__headImg"
                                    style={{
                                        backgroundImage: `url(${
                                            yourSelfNote.current.studentImage || '//simg01.gaodunwangxiao.com/v/Uploads/avatar/default.jpg'
                                        })`,
                                    }}
                                />
                            </div>
                            <div className="sub-tiku__commentContentBox">
                                <div>
                                    <div className="sub-tiku__commentUser">我</div>
                                    <div className="sub-tiku__question-note-like-box">
                                        <div
                                            className={classNames({
                                                'sub-tiku__question-note-like': yourSelfNote.current.isFabulous,
                                                'sub-tiku__question-note-not-like': !yourSelfNote.current.isFabulous,
                                            })}
                                            onClick={() => addCancelLike(yourSelfNote.current!)}
                                        />
                                        <span className="sub-tiku__likeNum">{yourSelfNote.current.fabulousNum}</span>
                                    </div>
                                </div>
                                <div
                                    className="sub-tiku__commentContentText"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(yourSelfNote.current.noteContent),
                                    }}
                                />
                                <div>
                                    <div
                                        style={{ color: 'rgba(0,0,0,0.34)' }}
                                        className="sub-tiku__tiku-default-btn sub-tiku__tiku-text-btn"
                                        onClick={() => deleteSelfNote()}
                                    >
                                        删除
                                    </div>
                                    <div className="sub-tiku__tiku-default-btn sub-tiku__tiku-text-btn" onClick={() => changeSelfNote()}>
                                        编辑
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {noteList.map(
                        item =>
                            !item.isSelf && (
                                <div className="sub-tiku__commentItem" key={item.noteId}>
                                    <div className="sub-tiku__commentHead">
                                        <div
                                            className="sub-tiku__headImg"
                                            style={{
                                                backgroundImage: `url(${
                                                    item.studentImage || '//simg01.gaodunwangxiao.com/v/Uploads/avatar/default.jpg'
                                                })`,
                                            }}
                                        />
                                    </div>
                                    <div className="sub-tiku__commentContentBox">
                                        <div>
                                            <div className="sub-tiku__commentUser">{item.studentName}</div>
                                            <div className="sub-tiku__question-note-like-box">
                                                <div
                                                    className={classNames({
                                                        'sub-tiku__question-note-like': item.isFabulous,
                                                        'sub-tiku__question-note-not-like': !item.isFabulous,
                                                    })}
                                                    onClick={() => addCancelLike(item)}
                                                />
                                                <span className="sub-tiku__likeNum">{item.fabulousNum}</span>
                                            </div>
                                        </div>

                                        <div
                                            className="sub-tiku__commentContentText"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(item.noteContent),
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuestionAnswerAndNote;
